import {mapState} from "vuex";

export default {
  data() {
    return {
      // 是否需要法官、书记员签字
      isNeedJudgeSign: false
    };
  },
  computed: {
    ...mapState({
      actId: state => state.user.actId,
    }),
  },
  created() {
    window.clickGoSignatureMaintenance = this.clickGoSignatureMaintenance;
  },
  methods: {
    verifyIntegrity() {
      return new Promise((resolve, reject) => {
        this.$api.getJudgeSignInfo({actId: this.actId}).then(res => {
          if (res.code && res.code.toString() === '200') {
            const result = res.data;
            if (Object.keys(result).length < 2) {
              this.errorTipHandler();
              reject(new Error('当前法官、书记员的签名缺失，请您到【个人中心-签名维护】中邀请法官、书记员上传签名！'));
            }
            resolve();
          } else {
            this.errorTipHandler();
            reject(new Error('当前法官、书记员的签名缺失，请您到【个人中心-签名维护】中邀请法官、书记员上传签名！'));
          }
        })
          .catch(() => {
            this.$message.error('系统异常，请稍后重试');
            reject(new Error('当前法官、书记员的签名缺失，请您到【个人中心-签名维护】中邀请法官、书记员上传签名！'));
          });
      });
    },
    errorTipHandler() {
      this.$message({
        type: 'error',
        dangerouslyUseHTMLString: true,
        message: `<p class="jp-error-tip-content">
          当前法官、书记员的签名缺失，请您到<span onclick="clickGoSignatureMaintenance()">【个人中心-签名维护】</span>中邀请法官、书记员上传签名！
        </p>`
      });
    },
    // 点击跳转
    clickGoSignatureMaintenance() {
      this.$router.replace({name: '签名维护'});
    },
    // methods end;
  }
};
